import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ISearchable } from '@common/contracts/components/searchable';
import { IListView } from 'src/app/shared/components/inputs/contracts/list-view';
import { Icd10Dto } from 'src/app/shared/models/icd10/icd10-dto.model';

@Component({
  selector: 'icd10-list-item',
  templateUrl: './icd10-list-item.html',
  styleUrls: ['../autocomplete-list-item.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class Icd10ListItem implements IListView {
  @Input() item: Icd10Dto;

  @Output() clicked: EventEmitter<ISearchable> = new EventEmitter<ISearchable>();

  triggerEvent(): void {
    this.clicked.emit(this.item);
  }
}
